var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconErrorRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0007 3.58398C9.18065 3.58398 2.83398 9.93065 2.83398 17.7507C2.83398 25.5707 9.18065 31.9173 17.0007 31.9173C24.8207 31.9173 31.1673 25.5707 31.1673 17.7507C31.1673 9.93065 24.8207 3.58398 17.0007 3.58398ZM17.0007 19.1673C16.2215 19.1673 15.584 18.5298 15.584 17.7507V12.084C15.584 11.3048 16.2215 10.6673 17.0007 10.6673C17.7798 10.6673 18.4173 11.3048 18.4173 12.084V17.7507C18.4173 18.5298 17.7798 19.1673 17.0007 19.1673ZM18.4173 24.834H15.584V22.0007H18.4173V24.834Z",
    fill: "#D0190F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorRed);
export default __webpack_public_path__ + "static/media/icon-error-red.b52c68eb501eb2eca3d2c590ffc00588.svg";
export { ForwardRef as ReactComponent };